export default __webpack_public_path__ + "static/media/cigar4.0cb44058.jpg";